/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

export const palette = {
  'neutral-dark-2': 'rgba(38, 52, 64, 0.02)',
  'neutral-light-2': 'rgba(207, 218, 226, 0.02)',
  'purple-dark-2': 'rgba(84, 61, 255, 0.02)',
  'purple-light-2': 'rgba(165, 153, 255, 0.02)',
  'teal-dark-2': 'rgba(0, 141, 163, 0.02)',
  'teal-light-2': 'rgba(100, 170, 180, 0.02)',
  'orange-dark-2': 'rgba(255, 85, 0, 0.02)',
  'orange-light-2': 'rgba(246, 126, 85, 0.02)',
  'red-dark-2': 'rgba(214, 64, 61, 0.02)',
  'red-light-2': 'rgba(255, 105, 102, 0.02)',
  'yellow-dark-2': 'rgba(194, 113, 0, 0.02)',
  'yellow-light-2': 'rgba(255, 159, 26, 0.02)',
  'green-dark-2': 'rgba(0, 133, 99, 0.02)',
  'green-light-2': 'rgba(0, 189, 142, 0.02)',
  'blue-dark-2': 'rgba(0, 118, 214, 0.02)',
  'blue-light-2': 'rgba(41, 159, 255, 0.02)',
  'white-2': 'rgba(255, 255, 255, 0.02)',
  'neutral-dark-3': 'rgba(38, 52, 64, 0.03)',
  'neutral-light-3': 'rgba(207, 218, 226, 0.03)',
  'purple-dark-3': 'rgba(84, 61, 255, 0.03)',
  'purple-light-3': 'rgba(165, 153, 255, 0.03)',
  'teal-dark-3': 'rgba(0, 141, 163, 0.03)',
  'teal-light-3': 'rgba(100, 170, 180, 0.03)',
  'orange-dark-3': 'rgba(255, 85, 0, 0.03)',
  'orange-light-3': 'rgba(246, 126, 85, 0.03)',
  'red-dark-3': 'rgba(214, 64, 61, 0.03)',
  'red-light-3': 'rgba(255, 105, 102, 0.03)',
  'yellow-dark-3': 'rgba(194, 113, 0, 0.03)',
  'yellow-light-3': 'rgba(255, 159, 26, 0.03)',
  'green-dark-3': 'rgba(0, 133, 99, 0.03)',
  'green-light-3': 'rgba(0, 189, 142, 0.03)',
  'blue-dark-3': 'rgba(0, 118, 214, 0.03)',
  'blue-light-3': 'rgba(41, 159, 255, 0.03)',
  'white-3': 'rgba(255, 255, 255, 0.03)',
  'neutral-dark-4': 'rgba(38, 52, 64, 0.04)',
  'neutral-light-4': 'rgba(207, 218, 226, 0.04)',
  'purple-dark-4': 'rgba(84, 61, 255, 0.04)',
  'purple-light-4': 'rgba(165, 153, 255, 0.04)',
  'teal-dark-4': 'rgba(0, 141, 163, 0.04)',
  'teal-light-4': 'rgba(100, 170, 180, 0.04)',
  'orange-dark-4': 'rgba(255, 85, 0, 0.04)',
  'orange-light-4': 'rgba(246, 126, 85, 0.04)',
  'red-dark-4': 'rgba(214, 64, 61, 0.04)',
  'red-light-4': 'rgba(255, 105, 102, 0.04)',
  'yellow-dark-4': 'rgba(194, 113, 0, 0.04)',
  'yellow-light-4': 'rgba(255, 159, 26, 0.04)',
  'green-dark-4': 'rgba(0, 133, 99, 0.04)',
  'green-light-4': 'rgba(0, 189, 142, 0.04)',
  'blue-dark-4': 'rgba(0, 118, 214, 0.04)',
  'blue-light-4': 'rgba(41, 159, 255, 0.04)',
  'white-4': 'rgba(255, 255, 255, 0.04)',
  'neutral-dark-8': 'rgba(38, 52, 64, 0.08)',
  'neutral-light-8': 'rgba(207, 218, 226, 0.08)',
  'purple-dark-8': 'rgba(84, 61, 255, 0.08)',
  'purple-light-8': 'rgba(165, 153, 255, 0.08)',
  'teal-dark-8': 'rgba(0, 141, 163, 0.08)',
  'teal-light-8': 'rgba(100, 170, 180, 0.08)',
  'orange-dark-8': 'rgba(255, 85, 0, 0.08)',
  'orange-light-8': 'rgba(246, 126, 85, 0.08)',
  'red-dark-8': 'rgba(214, 64, 61, 0.08)',
  'red-light-8': 'rgba(255, 105, 102, 0.08)',
  'yellow-dark-8': 'rgba(194, 113, 0, 0.08)',
  'yellow-light-8': 'rgba(255, 159, 26, 0.08)',
  'green-dark-8': 'rgba(0, 133, 99, 0.08)',
  'green-light-8': 'rgba(0, 189, 142, 0.08)',
  'blue-dark-8': 'rgba(0, 118, 214, 0.08)',
  'blue-light-8': 'rgba(41, 159, 255, 0.08)',
  'white-8': 'rgba(255, 255, 255, 0.08)',
  'neutral-dark-12': 'rgba(38, 52, 64, 0.12)',
  'neutral-light-12': 'rgba(207, 218, 226, 0.12)',
  'purple-dark-12': 'rgba(84, 61, 255, 0.12)',
  'purple-light-12': 'rgba(165, 153, 255, 0.12)',
  'teal-dark-12': 'rgba(0, 141, 163, 0.12)',
  'teal-light-12': 'rgba(100, 170, 180, 0.12)',
  'orange-dark-12': 'rgba(255, 85, 0, 0.12)',
  'orange-light-12': 'rgba(246, 126, 85, 0.12)',
  'red-dark-12': 'rgba(214, 64, 61, 0.12)',
  'red-light-12': 'rgba(255, 105, 102, 0.12)',
  'yellow-dark-12': 'rgba(194, 113, 0, 0.12)',
  'yellow-light-12': 'rgba(255, 159, 26, 0.12)',
  'green-dark-12': 'rgba(0, 133, 99, 0.12)',
  'green-light-12': 'rgba(0, 189, 142, 0.12)',
  'blue-dark-12': 'rgba(0, 118, 214, 0.12)',
  'blue-light-12': 'rgba(41, 159, 255, 0.12)',
  'white-12': 'rgba(255, 255, 255, 0.12)',
  'neutral-dark-16': 'rgba(38, 52, 64, 0.16)',
  'neutral-light-16': 'rgba(207, 218, 226, 0.16)',
  'purple-dark-16': 'rgba(84, 61, 255, 0.16)',
  'purple-light-16': 'rgba(165, 153, 255, 0.16)',
  'teal-dark-16': 'rgba(0, 141, 163, 0.16)',
  'teal-light-16': 'rgba(100, 170, 180, 0.16)',
  'orange-dark-16': 'rgba(255, 85, 0, 0.16)',
  'orange-light-16': 'rgba(246, 126, 85, 0.16)',
  'red-dark-16': 'rgba(214, 64, 61, 0.16)',
  'red-light-16': 'rgba(255, 105, 102, 0.16)',
  'yellow-dark-16': 'rgba(194, 113, 0, 0.16)',
  'yellow-light-16': 'rgba(255, 159, 26, 0.16)',
  'green-dark-16': 'rgba(0, 133, 99, 0.16)',
  'green-light-16': 'rgba(0, 189, 142, 0.16)',
  'blue-dark-16': 'rgba(0, 118, 214, 0.16)',
  'blue-light-16': 'rgba(41, 159, 255, 0.16)',
  'white-16': 'rgba(255, 255, 255, 0.16)',
  'neutral-dark-20': 'rgba(38, 52, 64, 0.2)',
  'neutral-light-20': 'rgba(207, 218, 226, 0.2)',
  'purple-dark-20': 'rgba(84, 61, 255, 0.2)',
  'purple-light-20': 'rgba(165, 153, 255, 0.2)',
  'teal-dark-20': 'rgba(0, 141, 163, 0.2)',
  'teal-light-20': 'rgba(100, 170, 180, 0.2)',
  'orange-dark-20': 'rgba(255, 85, 0, 0.2)',
  'orange-light-20': 'rgba(246, 126, 85, 0.2)',
  'red-dark-20': 'rgba(214, 64, 61, 0.2)',
  'red-light-20': 'rgba(255, 105, 102, 0.2)',
  'yellow-dark-20': 'rgba(194, 113, 0, 0.2)',
  'yellow-light-20': 'rgba(255, 159, 26, 0.2)',
  'green-dark-20': 'rgba(0, 133, 99, 0.2)',
  'green-light-20': 'rgba(0, 189, 142, 0.2)',
  'blue-dark-20': 'rgba(0, 118, 214, 0.2)',
  'blue-light-20': 'rgba(41, 159, 255, 0.2)',
  'white-20': 'rgba(255, 255, 255, 0.2)',
  'neutral-dark-24': 'rgba(38, 52, 64, 0.24)',
  'neutral-light-24': 'rgba(207, 218, 226, 0.24)',
  'purple-dark-24': 'rgba(84, 61, 255, 0.24)',
  'purple-light-24': 'rgba(165, 153, 255, 0.24)',
  'teal-dark-24': 'rgba(0, 141, 163, 0.24)',
  'teal-light-24': 'rgba(100, 170, 180, 0.24)',
  'orange-dark-24': 'rgba(255, 85, 0, 0.24)',
  'orange-light-24': 'rgba(246, 126, 85, 0.24)',
  'red-dark-24': 'rgba(214, 64, 61, 0.24)',
  'red-light-24': 'rgba(255, 105, 102, 0.24)',
  'yellow-dark-24': 'rgba(194, 113, 0, 0.24)',
  'yellow-light-24': 'rgba(255, 159, 26, 0.24)',
  'green-dark-24': 'rgba(0, 133, 99, 0.24)',
  'green-light-24': 'rgba(0, 189, 142, 0.24)',
  'blue-dark-24': 'rgba(0, 118, 214, 0.24)',
  'blue-light-24': 'rgba(41, 159, 255, 0.24)',
  'white-24': 'rgba(255, 255, 255, 0.24)',
  'neutral-dark-32': 'rgba(38, 52, 64, 0.32)',
  'neutral-light-32': 'rgba(207, 218, 226, 0.32)',
  'purple-dark-32': 'rgba(84, 61, 255, 0.32)',
  'purple-light-32': 'rgba(165, 153, 255, 0.32)',
  'teal-dark-32': 'rgba(0, 141, 163, 0.32)',
  'teal-light-32': 'rgba(100, 170, 180, 0.32)',
  'orange-dark-32': 'rgba(255, 85, 0, 0.32)',
  'orange-light-32': 'rgba(246, 126, 85, 0.32)',
  'red-dark-32': 'rgba(214, 64, 61, 0.32)',
  'red-light-32': 'rgba(255, 105, 102, 0.32)',
  'yellow-dark-32': 'rgba(194, 113, 0, 0.32)',
  'yellow-light-32': 'rgba(255, 159, 26, 0.32)',
  'green-dark-32': 'rgba(0, 133, 99, 0.32)',
  'green-light-32': 'rgba(0, 189, 142, 0.32)',
  'blue-dark-32': 'rgba(0, 118, 214, 0.32)',
  'blue-light-32': 'rgba(41, 159, 255, 0.32)',
  'white-32': 'rgba(255, 255, 255, 0.32)',
  'neutral-dark-40': 'rgba(38, 52, 64, 0.4)',
  'neutral-light-40': 'rgba(207, 218, 226, 0.4)',
  'purple-dark-40': 'rgba(84, 61, 255, 0.4)',
  'purple-light-40': 'rgba(165, 153, 255, 0.4)',
  'teal-dark-40': 'rgba(0, 141, 163, 0.4)',
  'teal-light-40': 'rgba(100, 170, 180, 0.4)',
  'orange-dark-40': 'rgba(255, 85, 0, 0.4)',
  'orange-light-40': 'rgba(246, 126, 85, 0.4)',
  'red-dark-40': 'rgba(214, 64, 61, 0.4)',
  'red-light-40': 'rgba(255, 105, 102, 0.4)',
  'yellow-dark-40': 'rgba(194, 113, 0, 0.4)',
  'yellow-light-40': 'rgba(255, 159, 26, 0.4)',
  'green-dark-40': 'rgba(0, 133, 99, 0.4)',
  'green-light-40': 'rgba(0, 189, 142, 0.4)',
  'blue-dark-40': 'rgba(0, 118, 214, 0.4)',
  'blue-light-40': 'rgba(41, 159, 255, 0.4)',
  'white-40': 'rgba(255, 255, 255, 0.4)',
  'neutral-dark-48': 'rgba(38, 52, 64, 0.48)',
  'neutral-light-48': 'rgba(207, 218, 226, 0.48)',
  'purple-dark-48': 'rgba(84, 61, 255, 0.48)',
  'purple-light-48': 'rgba(165, 153, 255, 0.48)',
  'teal-dark-48': 'rgba(0, 141, 163, 0.48)',
  'teal-light-48': 'rgba(100, 170, 180, 0.48)',
  'orange-dark-48': 'rgba(255, 85, 0, 0.48)',
  'orange-light-48': 'rgba(246, 126, 85, 0.48)',
  'red-dark-48': 'rgba(214, 64, 61, 0.48)',
  'red-light-48': 'rgba(255, 105, 102, 0.48)',
  'yellow-dark-48': 'rgba(194, 113, 0, 0.48)',
  'yellow-light-48': 'rgba(255, 159, 26, 0.48)',
  'green-dark-48': 'rgba(0, 133, 99, 0.48)',
  'green-light-48': 'rgba(0, 189, 142, 0.48)',
  'blue-dark-48': 'rgba(0, 118, 214, 0.48)',
  'blue-light-48': 'rgba(41, 159, 255, 0.48)',
  'white-48': 'rgba(255, 255, 255, 0.48)',
  'neutral-dark-64': 'rgba(38, 52, 64, 0.64)',
  'neutral-light-64': 'rgba(207, 218, 226, 0.64)',
  'purple-dark-64': 'rgba(84, 61, 255, 0.64)',
  'purple-light-64': 'rgba(165, 153, 255, 0.64)',
  'teal-dark-64': 'rgba(0, 141, 163, 0.64)',
  'teal-light-64': 'rgba(100, 170, 180, 0.64)',
  'orange-dark-64': 'rgba(255, 85, 0, 0.64)',
  'orange-light-64': 'rgba(246, 126, 85, 0.64)',
  'red-dark-64': 'rgba(214, 64, 61, 0.64)',
  'red-light-64': 'rgba(255, 105, 102, 0.64)',
  'yellow-dark-64': 'rgba(194, 113, 0, 0.64)',
  'yellow-light-64': 'rgba(255, 159, 26, 0.64)',
  'green-dark-64': 'rgba(0, 133, 99, 0.64)',
  'green-light-64': 'rgba(0, 189, 142, 0.64)',
  'blue-dark-64': 'rgba(0, 118, 214, 0.64)',
  'blue-light-64': 'rgba(41, 159, 255, 0.64)',
  'white-64': 'rgba(255, 255, 255, 0.64)',
  'neutral-dark-80': 'rgba(38, 52, 64, 0.8)',
  'neutral-light-80': 'rgba(207, 218, 226, 0.8)',
  'purple-dark-80': 'rgba(84, 61, 255, 0.8)',
  'purple-light-80': 'rgba(165, 153, 255, 0.8)',
  'teal-dark-80': 'rgba(0, 141, 163, 0.8)',
  'teal-light-80': 'rgba(100, 170, 180, 0.8)',
  'orange-dark-80': 'rgba(255, 85, 0, 0.8)',
  'orange-light-80': 'rgba(246, 126, 85, 0.8)',
  'red-dark-80': 'rgba(214, 64, 61, 0.8)',
  'red-light-80': 'rgba(255, 105, 102, 0.8)',
  'yellow-dark-80': 'rgba(194, 113, 0, 0.8)',
  'yellow-light-80': 'rgba(255, 159, 26, 0.8)',
  'green-dark-80': 'rgba(0, 133, 99, 0.8)',
  'green-light-80': 'rgba(0, 189, 142, 0.8)',
  'blue-dark-80': 'rgba(0, 118, 214, 0.8)',
  'blue-light-80': 'rgba(41, 159, 255, 0.8)',
  'white-80': 'rgba(255, 255, 255, 0.8)',
  'neutral-dark-100': 'rgba(38, 52, 64, 1)',
  'neutral-light-100': 'rgba(207, 218, 226, 1)',
  'purple-dark-100': 'rgba(84, 61, 255, 1)',
  'purple-light-100': 'rgba(165, 153, 255, 1)',
  'teal-dark-100': 'rgba(0, 141, 163, 1)',
  'teal-light-100': 'rgba(100, 170, 180, 1)',
  'orange-dark-100': 'rgba(255, 85, 0, 1)',
  'orange-light-100': 'rgba(246, 126, 85, 1)',
  'red-dark-100': 'rgba(214, 64, 61, 1)',
  'red-light-100': 'rgba(255, 105, 102, 1)',
  'yellow-dark-100': 'rgba(194, 113, 0, 1)',
  'yellow-light-100': 'rgba(255, 159, 26, 1)',
  'green-dark-100': 'rgba(0, 133, 99, 1)',
  'green-light-100': 'rgba(0, 189, 142, 1)',
  'blue-dark-100': 'rgba(0, 118, 214, 1)',
  'blue-light-100': 'rgba(41, 159, 255, 1)',
  'white-100': 'rgba(255, 255, 255, 1)',
}
